import axios from "axios";
import {appConfig} from "config/defaultConfig";

const CTIA_SERVICES = appConfig.APP.CTIA_SERVICES;

export function fetchCasebookCase(caseId) {
  const id = caseId.startsWith("casebook-") ? caseId : `casebook-${caseId}`;

  return axios
    .get(
      `${window.CONFIG.privateCtiaUrl}${
        CTIA_SERVICES.ROUTES.CASEBOOK
      }/${encodeURIComponent(id)}`,
      {}
    )
    .then((resp) => {
      return resp.data;
    });
}

export function getObservablesFromCase(caseId) {
  const request = fetchCasebookCase(caseId);

  return request
    .then((casebookCase) => {
      return casebookCase ? casebookCase.observables : [];
    })
    .catch(() => {
      return [];
    });
}
